import { GOLD, GOLD_LIGHT, NAVY, WHITE } from '../lib/ui';

export default function Modal({ title, onClose, children, wide }) {
  return (
    <div className="modal-overlay" style={{
      position:'fixed', inset:0, background:'rgba(10,18,35,0.65)', zIndex:1000,
      display:'flex', alignItems:'center', justifyContent:'center', padding:16
    }} onClick={onClose}>
      <div className="modal-card" onClick={e=>e.stopPropagation()} style={{
        background:WHITE, borderRadius:12, width:'100%', maxWidth:wide?920:660,
        maxHeight:'92vh', overflow:'auto', boxShadow:'0 24px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          padding:'18px 24px', borderBottom:`2px solid ${GOLD}`, display:'flex',
          justifyContent:'space-between', alignItems:'center',
          background:NAVY, borderRadius:'12px 12px 0 0', position:'sticky', top:0, zIndex:1
        }}>
          <span style={{ color:GOLD, fontFamily:'Georgia,serif', fontSize:17, fontWeight:700 }}>{title}</span>
          <button onClick={onClose} style={{ background:'none', border:'none', color:GOLD_LIGHT, cursor:'pointer', fontSize:24, lineHeight:1, padding:'0 4px' }}>x</button>
        </div>
        <div style={{ padding:20 }}>{children}</div>
      </div>
    </div>
  );
}
